import(/* webpackMode: "eager" */ "/home/app/app/[locale]/page.tsx");
